import commonModule from "./en/common";
import userModule from "./en/user";
import loginModule from "./en/login";
import registerModule from "./en/register";
import questionModule from "./en/question";
import statusModule from "./en/status";
import codeModule from "./en/errorCode";
import { storeModule, evaluationModule } from "./en/store";
import { orderModule } from "./en/order";
import { homeModule, searchModule } from "./en/home";
import { otherModule } from "./en/other";
const en = {
  commonBox: commonModule,
  loginBox: loginModule,
  registerBox: registerModule,
  questionBox: questionModule,
  //店铺详情
  storeDetail: storeModule,
  //评价部分
  evaluationBox: evaluationModule,
  orderModule: orderModule,
  //首页
  home: homeModule,
  searchModule: searchModule,
  userModule: userModule,
  //状态
  status: statusModule,
  //错误码
  errorCode: codeModule,
  otherModule: otherModule
};
export default en;
